import { LOCALES } from 'i18n/locales';

export const feedbackPageIntl = {
    [LOCALES.ENGLISH]: {
        'feedbackPage.title': 'Feedback',
        'feedbackPage.error.message': 'If your issue persists, please contact the NUAR service desk for additional support.'
    },
    [LOCALES.WELSH]: {
        'feedbackPage.title': 'Adborth',
        'feedbackPage.error.message': 'Os bydd eich problem yn parhau, cysylltwch â\'r ddesg wasanaeth NUAR am gymorth ychwanegol.'
    }
};
